import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '@/store/store';

import CheckoutSession from '@/models/checkout/CheckoutSession';

// This hook behaves a little differently, since CheckoutSession not set by an API response
// Model sets step data directly to local Redux store
// Step data is written in useCheckout hook for use by components

// This means, in here, we DON'T set data to Redux, we just read it to prevent circular imports

const useCheckout = () => {
	
	// Access Redux state
	const activeStepDataRedux = useSelector((state: RootState) => state.checkout.stepData);

	// Local state for hydration handling
	const [hydratedCheckoutSession, setHydratedCheckoutSession] = useState<CheckoutSession | null>(null);
	// const [hydratedStepData, setHydratedStepData] = useState<Record<string, any> | null>(null);

	// Methods
	// None yet
	
	// Effects
	useEffect(() => {
		if(activeStepDataRedux) {
			setHydratedCheckoutSession(new CheckoutSession({ stepData: activeStepDataRedux }));
		}
	}, [ activeStepDataRedux ]);

	return {
		checkoutSession: hydratedCheckoutSession,
	};
};
export default useCheckout;